// src/api/gastos.js
import { apiFetch } from './index.js';

const API_BASE = '/api/Gasto';

/**
 * Obtener todos los gastos
 */
export const obtenerGastos = async () => {
    try {
        const response = await apiFetch(API_BASE);
        return response;
    } catch (error) {
        console.error('Error al obtener gastos:', error);
        return { success: false, error: error.message };
    }
};

/**
 * Obtener un gasto por ID
 */
export const obtenerGastoPorId = async (id) => {
    try {
        const response = await apiFetch(`${API_BASE}/${id}`);
        return response;
    } catch (error) {
        console.error(`Error al obtener gasto ID ${id}:`, error);
        return { success: false, error: error.message };
    }
};

/**
 * Obtener categorías de gastos
 */
export const obtenerCategoriasGasto = async () => {
    try {
        const response = await apiFetch(`${API_BASE}/categorias`);
        return response;
    } catch (error) {
        console.error('Error al obtener categorías:', error);
        return { success: false, error: error.message };
    }
};

/**
 * Obtener gastos por proveedor
 */
export const obtenerGastosPorProveedor = async (proveedor) => {
    try {
        const response = await apiFetch(`${API_BASE}/proveedor/${encodeURIComponent(proveedor)}`);
        return response;
    } catch (error) {
        console.error(`Error al obtener gastos por proveedor ${proveedor}:`, error);
        return { success: false, error: error.message };
    }
};

/**
 * Obtener gastos por categoría
 */
export const obtenerGastosPorCategoria = async (categoria) => {
    try {
        const response = await apiFetch(`${API_BASE}/categoria/${encodeURIComponent(categoria)}`);
        return response;
    } catch (error) {
        console.error(`Error al obtener gastos por categoría ${categoria}:`, error);
        return { success: false, error: error.message };
    }
};

/**
 * Obtener gastos por fecha
 */
export const obtenerGastosPorFecha = async (fecha) => {
    try {
        const response = await apiFetch(`${API_BASE}/fecha/${fecha}`);
        return response;
    } catch (error) {
        console.error(`Error al obtener gastos por fecha ${fecha}:`, error);
        return { success: false, error: error.message };
    }
};

/**
 * Obtener resumen diario de gastos
 */
export const obtenerResumenDiario = async (fecha = null) => {
    try {
        let url = `${API_BASE}/resumen/dia`;
        if (fecha) {
            url += `?fecha=${fecha}`;
        }
        const response = await apiFetch(url);
        return response;
    } catch (error) {
        console.error('Error al obtener resumen diario:', error);
        return { success: false, error: error.message };
    }
};

/**
 * Obtener resumen semanal de gastos
 */
export const obtenerResumenSemanal = async (fecha = null) => {
    try {
        let url = `${API_BASE}/resumen/semana`;
        if (fecha) {
            url += `?fecha=${fecha}`;
        }
        const response = await apiFetch(url);
        return response;
    } catch (error) {
        console.error('Error al obtener resumen semanal:', error);
        return { success: false, error: error.message };
    }
};

/**
 * Obtener resumen mensual de gastos
 */
export const obtenerResumenMensual = async (fecha = null) => {
    try {
        let url = `${API_BASE}/resumen/mes`;
        if (fecha) {
            url += `?fecha=${fecha}`;
        }
        const response = await apiFetch(url);
        return response;
    } catch (error) {
        console.error('Error al obtener resumen mensual:', error);
        return { success: false, error: error.message };
    }
};

/**
 * Obtener resumen por período personalizado
 */
export const obtenerResumenPorPeriodo = async (fechaInicio, fechaFin) => {
    try {
        const response = await apiFetch(`${API_BASE}/resumen?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`);
        return response;
    } catch (error) {
        console.error('Error al obtener resumen por período:', error);
        return { success: false, error: error.message };
    }
};

/**
 * Crear un nuevo gasto
 */
export const crearGasto = async (data) => {
    try {
        const response = await apiFetch(API_BASE, {
            method: 'POST',
            body: JSON.stringify(data)
        });
        return response;
    } catch (error) {
        console.error('Error al crear gasto:', error);
        return { success: false, error: error.message };
    }
};

/**
 * Actualizar un gasto
 */
export const actualizarGasto = async (id, data) => {
    try {
        const response = await apiFetch(`${API_BASE}/${id}`, {
            method: 'PUT',
            body: JSON.stringify(data)
        });
        return response;
    } catch (error) {
        console.error(`Error al actualizar gasto ID ${id}:`, error);
        return { success: false, error: error.message };
    }
};

/**
 * Eliminar un gasto
 */
export const eliminarGasto = async (id) => {
    try {
        const response = await apiFetch(`${API_BASE}/${id}`, {
            method: 'DELETE'
        });
        return response;
    } catch (error) {
        console.error(`Error al eliminar gasto ID ${id}:`, error);
        return { success: false, error: error.message };
    }
};